import type { InstanceOptionSet } from "building-types/options/optionSet";
import type { Table } from "common/data/table";

// For a given archetype option set ID, gets a map of the instance option set IDs with that archetype.
export function buildInstanceOptionSetIdsByArchetype(
  instanceOptionSets: Table<InstanceOptionSet>,
): Record<string, string[]> {
  const result: Record<string, string[]> = {};
  for (const instanceId in instanceOptionSets) {
    const { archetypeId } = instanceOptionSets[instanceId];
    if (!result[archetypeId]) {
      result[archetypeId] = [];
    }
    result[archetypeId].push(instanceId);
  }
  return result;
}
